import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    boxShadow:'rgba(0, 0, 0, 0.15) 0px 0px 15px',
    borderRadius: '1rem',
    '& .MuiCardHeader-root': {
        position: 'relative',
        '& .MuiLinearProgress-root': {
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
        '& .MuiCardHeader-title': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
            fontSize: '1.2rem',
            fontWeight: 400,
        },
        '& .MuiCardHeader-avatar': {
            marginRight: 0,
        },
        '& .MuiCardHeader-subheader': {
            '& .MuiTabs-root': {
                '& .MuiTab-root': {
                    fontSize: '0.9rem',
                    textTransform: 'capitalize',
                    fontWeight: 400,
                    color: theme.palette.text.secondary,
                },
            }
        }
    },
    '& .MuiCardContent-root': {
        '& .MuiTableContainer-root': {
            '& .MuiTable-root': {
                '& .MuiTableHead-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-root': {
                            fontWeight: 400,
                            fontSize: '0.85rem',
                            textTransform: 'capitalize',
                        },
                    },
                },
                '& .MuiTableBody-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-root': {
                            fontWeight: 400,
                            color: theme.palette.text.primary,
                            fontSize: '0.95rem',
                            textTransform: 'capitalize',
                            '& .MuiAvatar-root': {},
                        },
                    },
                },
                '& .MuiTableFooter-root': {},
            },
        },
        '& .MuiAccordionDetails-root': {
            '&>.MuiTypography-root': {
                fontStyle: 'italic',
                fontSize: '0.9rem',
                position: 'relative',
                '&::after': {
                    content: '""',
                    display: 'block',
                    width: '20px',
                    height: '0',
                    borderBottom: `4px solid ${theme.palette.text.primary}`,
                    marginTop: theme.spacing(1),
                }
            },
            '& .MuiList-root': {
                '& .MuiListItem-root': {
                    borderBottom: `1px dashed ${theme.palette.divider}`,
                    '&:last-child': {
                        borderBottom: 'none',
                    },
                    '& .MuiListItemText-root': {
                        '& .MuiTypography-body1': {
                            fontSize: '0.875rem',
                            fontWeight: 400,
                            color: theme.palette.text.primary,
                        },
                        '& .MuiTypography-body2': {
                            fontSize: '0.8rem',
                            color: theme.palette.text.secondary,
                        },
                    },
                },
            },
        }
    },
    '& .MuiCardActions-root': {
        padding: theme.spacing(3),
        width: '100%',
        justifyContent: 'space-between',
    }
}));


export const SearchCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}